module.exports = __webpack_public_path__ + "img/Kinoko-Table-01.89b53b9b.jpg";